import { InboxEntryPriority } from '@this+that/models';

export const DOBOX_FORM_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
  RECURRENCE_EDIT: 'recurrence_edit',
} as const;

export type DoBoxFormMode =
  (typeof DOBOX_FORM_MODE)[keyof typeof DOBOX_FORM_MODE];

export interface DoBoxFormInitialValues {
  subject?: string;
  description?: string;
  taskGroupId?: string;
  taskSubgroupId?: string;
  taskLabelIds?: string[];
  participantIds?: string[];
  dueAt?: number;
  priority?: InboxEntryPriority;
}
